/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type ItemPrice_item$ref = any;
type ItemShipping_item$ref = any;
type ItemStatus_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type ListRow_item$ref: FragmentReference;
export type ListRow_item = {|
  +localizedPdpUrl: ?string,
  +serviceId: ?string,
  +title: ?string,
  +isArt: ?boolean,
  +classification: ?{|
    +creationDate: ?string
  |},
  +creators: ?$ReadOnlyArray<?{|
    +creator: ?{|
      +displayName: ?string
    |}
  |}>,
  +seller: ?{|
    +serviceId: ?string,
    +sellerProfile: ?{|
      +company: ?string
    |},
  |},
  +firstPhotoWebPath: ?string,
  +$fragmentRefs: ItemPrice_item$ref & ItemStatus_item$ref & ItemShipping_item$ref,
  +$refType: ListRow_item$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ListRow_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "creators",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemCreator",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "creator",
          "storageKey": null,
          "args": null,
          "concreteType": "Creator",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "displayName",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "localizedPdpUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isArt",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "classification",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemClassification",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "creationDate",
          "args": null,
          "storageKey": null
        }
      ]
    },
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "seller",
      "storageKey": null,
      "args": null,
      "concreteType": "Seller",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "sellerProfile",
          "storageKey": null,
          "args": null,
          "concreteType": "SellerProfile",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "company",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "firstPhotoWebPath",
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "large",
          "type": "ImageVersionTypeName!"
        }
      ],
      "storageKey": "firstPhotoWebPath(size:\"large\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "ItemPrice_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ItemStatus_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ItemShipping_item",
      "args": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'dbbcd4256eef104386179898b7cf7188';
module.exports = node;
